(function ($) {

    /**
     * Constructor
     *
     * @param options
     * @constructor
     */
    function ChangeBusinessWanted(options) {
        console.log('ChangeBusinessWanted initialization');

        if (!options) {
            throw new Error('No options passed to ChangeBusinessWanted constructor');
        }

        this.options = $.extend({}, ChangeBusinessForSale.defaults, options);
        this.setup();
    }

    /**
     * Setup hooks
     */
    ChangeBusinessWanted.prototype.setup = function () {
        let self = this;
        let body = $('body');

        $('#change-business-wanted').on('submit', function (event) {
            event.preventDefault();
            if (!self.validate()) {
                return;
            }

            $('#message').hide().removeClass('alert-danger').removeClass('alert-success').empty()
            let fd = new FormData();
            fd.append('action', self.options.action);
            fd.append('businessID', $('#business-id').val());
            fd.append('businessTitle', $('#business-title').val());
            fd.append('minRevenue', $('#min_revenue').val());
            fd.append('maxRevenue', $('#max_revenue').val());
            fd.append('industry', $('#business-industry option:selected').val());
            fd.append('businessDescription', $('#business-description').val());

            let regions = $('.rigion-check-list input:checked');
            let result = [];
            regions.each(function (key, value) {
                result.push($(value).val());
            });
            fd.append('regions', JSON.stringify(result));

            self.sendRequest(fd);
        });

        body.on('input', '#business-title', function (event) {
            event.preventDefault();
            self.checkTitleLength();
        });

        this.addNumberFields();
    }

    ChangeBusinessWanted.prototype.checkTitleLength = function () {
        console.log('change');
        let notice = $('#business-title-length-notice');
        if ($('#business-title').val().length >= 70) {
            notice.show();
        } else {
            notice.hide();
        }
    }

    ChangeBusinessWanted.prototype.validate = function () {
        let isValid = true;

        let businessTitleField = $('#business-title');
        businessTitleField.closest('.input-wrapper').find('.warning').remove();
        if (!businessTitleField.val()) {
            businessTitleField.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        }

        let businessIndustry = $('#business-industry');
        businessIndustry.closest('.input-wrapper').find('.warning').remove();
        if (!businessIndustry.find('option:selected').val()) {
            businessIndustry.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        }

        let regionBlock = $('.rigion-check-list');
        regionBlock.closest('.input-wrapper').find('.warning').remove();
        if (!regionBlock.find('input:checked').length) {
            regionBlock.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
        }

        let minRevenue = $('#min_revenue');
        minRevenue.closest('.input-wrapper').find('.warning').remove();
        if (!minRevenue.val() || parseFloat(minRevenue.val()) < 0) {
            minRevenue.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        } else if (parseFloat(minRevenue.val()) <= 0) {
            minRevenue.closest('.input-wrapper').append('<span class="warning" style="color: red">Min revenue should be > 0</span>');
            isValid = false;
        }

        let maxRevenue = $('#max_revenue');
        maxRevenue.closest('.input-wrapper').find('.warning').remove();
        if (!maxRevenue.val()) {
            maxRevenue.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        } else if (parseFloat(maxRevenue.val()) <= 0) {
            maxRevenue.closest('.input-wrapper').append('<span class="warning" style="color: red">Max revenue should be > 0</span>');
            isValid = false;
        }

        let businessDescription = $('#business-description');
        businessDescription.closest('.input-wrapper').find('.warning').remove();
        if (!businessDescription.val().replace(/(<([^>]+)>)/ig, "")) {
            businessDescription.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        }

        return isValid;
    };

    ChangeBusinessWanted.prototype.addNumberFields = function () {
        new NumberInput({});
    }

    /**
     * Send AJAX request
     *
     * @param fd
     */
    ChangeBusinessWanted.prototype.sendRequest = function (fd) {
        let self = this;
        console.log('Send request');
        console.log(fd);

        jQuery.ajax({
            type: 'POST',
            url: self.options.apiRoute,
            data: fd,
            processData: false,
            contentType: false,
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
                self.disableInputs();
            },
            success: function (response) {
                self.parseResponse(response);
            },
            error: function (data) {
                console.log(data);
            }
        });
    }

    /**
     * Disable all elements on page
     */
    ChangeBusinessWanted.prototype.disableInputs = function () {
        let form = $('#change-business-wanted');
        form.find('input').prop("disabled", true);
        form.find('select').prop("disabled", true);
        form.find('textarea').prop("disabled", true);
        $('#spinner').show();
    }

    /**
     * Enable all elements on page
     */
    ChangeBusinessWanted.prototype.enableInputs = function () {
        let form = $('#change-business-wanted');
        form.find('input').prop("disabled", false);
        form.find('select').prop("disabled", false);
        form.find('textarea').prop("disabled", false);
        $('#spinner').hide();
    }

    /**
     * Parse response
     *
     * @param response
     */
    ChangeBusinessWanted.prototype.parseResponse = function (response) {
        let self = this;
        let message = $('#message');
        console.log(response);
        if (response.status !== 'success') {
            self.enableInputs();
            message.append(response.message).addClass('alert-danger').show();
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.dashboard-heading').offset().top - 60
            }, 500);
            return;
        }

        if (response.redirect_URL !== 'undefined' && response.redirect_URL) {
            window.location.href = response.redirect_URL;
        } else {
            message.append(response.message).addClass('alert-success').show();
            $('#change-business-wanted').hide();
            $('.dashboard-credit-btn').empty().append(response.credits);
        }
    }

    ChangeBusinessWanted.defaults = {};
    window.ChangeBusinessWanted = ChangeBusinessWanted;

})(jQuery);